import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da29153k8r5te5mqsjs0";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // 反垃圾蜜罐：若被机器人填写则静默通过，不提交
    const honey = formData.get("website_alt");
    if (typeof honey === "string" && honey.trim() !== "") {
      setStatus("success");
      setMessage("订阅成功，欢迎每天来吃瓜速递刷新热点！");
      form.reset();
      return;
    }

    setStatus("loading");
    setMessage("");
    const payload = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      if (key === "website_alt") continue;
      if (typeof value === "string" && value.trim() !== "") payload.append(key, value);
    }

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText || "";
      const spamHit = /spam|form data is spam/i.test(serverMsg);

      if (!response.ok || spamHit || parsed?.code !== "OK") {
        setStatus("error");
        setMessage(serverMsg && !spamHit ? serverMsg : "提交失败，请稍后再试。");
        return;
      }
      setStatus("success");
      setMessage("订阅成功，欢迎每天来吃瓜速递刷新热点！");
      form.reset();
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <section className="container-x py-12 md:py-16">
      <div className="relative overflow-hidden rounded-lg bg-primary-600">
        <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-primary-400/40 blur-2xl"></div>
        <div className="absolute -bottom-12 left-1/4 h-40 w-40 rounded-full bg-secondary-500/40 blur-2xl"></div>
        <div className="relative z-10 grid grid-cols-1 items-center gap-6 p-6 md:grid-cols-2 md:p-10">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-mail-send-line"></i>
              订阅吃瓜速递
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              每日热点，不错过任何精彩
            </h2>
            <p className="mt-3 max-w-md text-sm leading-6 text-background-50/85">
              留下邮箱，订阅最新热点与八卦汇总速递提醒，第一时间掌握吃瓜动态。
            </p>
          </div>

          <div>
            <form
              id="subscribe-form"
              data-readdy-form
              onSubmit={onSubmit}
              className="flex flex-col gap-2 sm:flex-row"
            >
              <div className="relative flex-1">
                <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-background-50/70"></i>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱"
                  className="h-12 w-full rounded-md border border-background-50/25 bg-background-50 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-background-50 focus:outline-none focus:ring-2 focus:ring-background-50/40"
                />
                {/* 反垃圾蜜罐字段（对用户不可见） */}
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-honey"
                />
              </div>
              <button
                type="submit"
                disabled={status === "loading"}
                className="h-12 whitespace-nowrap rounded-md bg-background-50 px-6 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100 disabled:opacity-70"
              >
                {status === "loading" ? "提交中…" : "订阅提醒"}
              </button>
            </form>

            {status === "success" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm text-background-50">
                <i className="ri-checkbox-circle-fill"></i>
                {message}
              </p>
            )}
            {status === "error" && (
              <p className="mt-3 flex items-center gap-1.5 text-sm text-background-50">
                <i className="ri-error-warning-fill"></i>
                {message}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}